export interface TachographInfringementDetails {
  minutes?: number
  vehicleBefore?: string
  vehicleAfter?: string
  countryLeft?: string
  countryEntered?: string
  countryLeftIso?: string
  countryEnteredIso?: string
}

const asString = (value: unknown) =>
  typeof value === 'string' && value !== '' ? value : undefined

/**
 * The backend sends `details` as a JSON string written by the rule that found
 * the infringement. Unknown or malformed content yields no details rather than
 * an error, so an older row never breaks the page.
 */
export function parseTachographInfringementDetails(
  details: unknown
): TachographInfringementDetails {
  let parsed: unknown = details
  if (typeof details === 'string') {
    try {
      parsed = JSON.parse(details)
    } catch {
      return {}
    }
  }
  if (!parsed || typeof parsed !== 'object') return {}

  const raw = parsed as Record<string, unknown>
  return {
    minutes: typeof raw.minutes === 'number' ? raw.minutes : undefined,
    vehicleBefore: asString(raw.vehicle_before),
    vehicleAfter: asString(raw.vehicle_after),
    countryLeft: asString(raw.country_left),
    countryEntered: asString(raw.country_entered),
    countryLeftIso: asString(raw.country_left_iso),
    countryEnteredIso: asString(raw.country_entered_iso),
  }
}
